query GetCompetitorIqWebsites {
    competitorIqSettings {
        predictedWebsite
        website
        competitors
    }
}
